module.exports = __webpack_public_path__ + "img/r25-50.3bd502be.png";